"use client"

import { Tabs, TabsContent } from "@/components/ui/tabs"
import { HubTabs } from "@/components/hub-tabs"
import { MigrationsPage } from "@/components/migrations/migrations-page"
import { ProvidersPage } from "@/components/providers/providers-page"
import { MappingsPage } from "@/components/mappings/mappings-page"
import { BackfillPage } from "@/components/backfill/backfill-page"
import { useHubCounts } from "@/hooks/use-hub-counts"
import { useTranslation } from "@/hooks/use-translation"

export default function PayrollIntegrationsPage() {
  const { t } = useTranslation()
  const counts = useHubCounts()

  return (
    // Full-bleed like Timesheet Hub: the MFE fills the iframe width, no max-width cap.
    <main id="main-content" className="px-6 py-5">
      {/* Header band, as on the ATS Hub: title and tagline on one line. */}
      <div className="mb-3 flex items-center justify-between gap-3 rounded-lg border border-[var(--th-card-border)] bg-[var(--th-meta-bg)] px-5 py-2.5">
        <div className="flex flex-wrap items-baseline gap-x-3">
          {/* Timesheet Hub page title: Manrope 17px ExtraBold, tight tracking. */}
          <h1 className="font-heading text-[17px] font-extrabold leading-tight tracking-[-0.17px]">
            {t("page.title")}
          </h1>
          <span className="hidden text-xs text-muted-foreground sm:inline">{t("page.subtitle")}</span>
        </div>
      </div>

      <Tabs defaultValue="migrations">
        <HubTabs counts={counts} />

        <TabsContent value="migrations" className="mt-4">
          <MigrationsPage />
        </TabsContent>

        <TabsContent value="providers" className="mt-4">
          <ProvidersPage />
        </TabsContent>

        <TabsContent value="mappings" className="mt-4">
          <MappingsPage />
        </TabsContent>

        <TabsContent value="backfill" className="mt-4">
          <BackfillPage />
        </TabsContent>
      </Tabs>
    </main>
  )
}
